/* eslint-disable import/prefer-default-export */

import http from '../core/HttpClient';
import urls from '../constants/urls';

import { SET_USER_AUTHENTICATED, GET_USER_PRIVILIGES } from '../constants';

export function setUserAuthenticated(userId) {
  return {
    type: 'authenticated',
    userId,
  };
}

export function getUserPriviliges() {
  return {
    type: GET_USER_PRIVILIGES,
    promise: http.get(`${urls.API_USERS}/priviliges`),
  };
}

export function login(username, password) {
  return {
    type: 'LOGIN',
    promise: http.post('/login', {username, password}),
  };
}


export function clearLoginActions() {
  return {
    type: 'CLEAR_LOGIN_ACTIONS',
  }
}


// WEBPACK FOOTER //
// ./src/actions/authentication.js